import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/authorization/auth.service';
import { MSALGuardConfigFactory } from '../app.module';
import { SilentRequest } from '@azure/msal-browser';
import { AuthUtilService } from '../services/common/auth-util.service';
import { CommonService } from '../services/common/common.service';
import { LOGIN_TYPE_B2C, LS_LAST_ACTIVITY } from '../constants/app.constant';
import { EMPTY } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private common: CommonService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let newHeaders = request.clone({}).headers;

    if (
      environment.apimConfig.apimFlag &&
      environment.apimConfig.apimSubscriptionKey
    ) {
      // newHeaders = newHeaders.append('Ocp-Apim-Subscription-Key', environment.apimConfig.apimSubscriptionKey);
      newHeaders = newHeaders.append(
        'Ocp_apim_subscription_key',
        environment.apimConfig.apimSubscriptionKey
      );
      newHeaders = newHeaders.append('Ocp-Apim-Trace', 'true');
      newHeaders = newHeaders.append(
        'Caller',
        !!this.authService.loginType &&
          this.authService.loginType === LOGIN_TYPE_B2C
          ? environment.apimConfig.callerB2C
          : environment.apimConfig.caller
      );
    }

    if (!!this.authService.accessToken) {
      newHeaders = newHeaders.append(
        'Ad-Authorization',
        this.authService.accessToken
      );
      newHeaders = newHeaders.append(
        'Authorization',
        this.authService.accessToken
      );
    }
    // if (!!this.authService.appToken) {
    //   newHeaders = newHeaders.append(
    //     'Ad-Authorization',
    //     this.authService.appToken
    //   );
    //   newHeaders = newHeaders.append(
    //     'Authorization',
    //     this.authService.appToken
    //   );
    // }

    if (!!this.authService.appTokenApi) {
      newHeaders = newHeaders.append(
        'App-Authorization',
        this.authService.appTokenApi
      );
    }

    // // const token = this.authService.getToken();
    // const token = {access_token: ''};
    // if (token) {
    //   let authHeader = newHeaders.get('Authorization');
    //   if(authHeader){
    //     newHeaders = newHeaders.set('Authorization', 'Bearer ' + token.access_token)
    //   }else{
    //     newHeaders = newHeaders.append('Authorization', 'Bearer ' + token.access_token);
    //   }
    // }

    request = request.clone({ headers: newHeaders });
    // return next.handle(request);
    // return next.handle(request).pipe(
    //   catchError((error) => {
    //     if (error instanceof HttpErrorResponse && error.status === 401) {
    //       // return this.handle401Error(request, next, error);
    //     }
    //     return throwError(error);
    //   })
    // );
    // return this.checkToken(request, next);

    if (!environment.requireAuthen) {
      return this.continueProcess(request, next);
    }

    return this.authService.check().pipe(
      switchMap((authenticated) => {
        // If the user is not authenticated...
        if (!authenticated) {
          // Redirect to the sign-in page
          // Prevent the access
          return this.handleSessionExpired();
        }
        // Allow the access
        let newHeaders = request.clone({}).headers;
        if (!!this.authService.accessToken) {
          newHeaders = newHeaders.set(
            'Ad-Authorization',
            this.authService.accessToken
          );
          newHeaders = newHeaders.set(
            'Authorization',
            this.authService.accessToken
          );
        }
        if (!!this.authService.appTokenApi) {
          newHeaders = newHeaders.set(
            'App-Authorization',
            this.authService.appTokenApi
          );
        }
        request = request.clone({ headers: newHeaders });
        return this.continueProcess(request, next);
      })
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler,
    error: HttpErrorResponse
  ) {
    // console.log({...MSALGuardConfigFactory().authRequest});
    // return this.msalService
    //   .acquireTokenSilent({
    //     ...MSALGuardConfigFactory().authRequest,
    //   } as SilentRequest)
    //   .pipe(
    //     switchMap((token: any) => {
    //       // console.log('acquireTokenSilent', token);
    //       // this.tokenService.saveToken(token.accessToken);
    //       // this.refreshTokenSubject.next(token.accessToken);
    //       let newHeaders = request.clone({}).headers;
    //       let authHeader = newHeaders.get("Authorization");
    //       if (authHeader) {
    //         newHeaders = newHeaders.set(
    //           "Authorization",
    //           "Bearer " + token.idToken
    //         );
    //       } else {
    //         newHeaders = newHeaders.append(
    //           "Authorization",
    //           "Bearer " + token.idToken
    //         );
    //       }
    //       request = request.clone({ headers: newHeaders });
    //       this.authService.setADToken(token);
    //       return next.handle(request);
    //     }),
    //     catchError((err) => {
    //       // console.log('catchError', request, err);
    //       // this.tokenService.signOut();
    //       this.authService.logout();
    //       return throwError(err);
    //     })
    //   );
    //   return this.authService.extendMsalExpiry().pipe(
    //     switchMap((result) => {
    //       try {
    //         // Check the access token expire date
    //         if (AuthUtilService.isTokenExpired(this.authService.appToken)) {
    //           // check if last expiry is within session expiry --> refresh
    //           // const lastActivity = localStorage.getItem(LS_LAST_ACTIVITY);
    //           const lastActivity = this.common.getLocalStorage(LS_LAST_ACTIVITY);
    //           if (lastActivity) {
    //             const now = new Date();
    //             let lastActivityDate = new Date();
    //             lastActivityDate.setTime(Number(lastActivity));
    //             lastActivityDate.setTime(
    //               lastActivityDate.getTime() +
    //                 environment.manageAuth.session * 1000
    //             );
    //             // extend token if last activity + session time > current date
    //             if (lastActivityDate.getTime() >= now.getTime()) {
    //               this.authService.appToken =
    //                 this.authService.refreshTokenExpiryDate(
    //                   this.authService.appToken,
    //                   false
    //                 );
    //               // return of(true);
    //               setTimeout(() => {
    //                 let newHeaders = request.clone({}).headers;
    //                 if (
    //                   environment.apimConfig.apimFlag &&
    //                   environment.apimConfig.apimSubscriptionKey
    //                 ) {
    //                   newHeaders = newHeaders.append(
    //                     'Ocp_apim_subscription_key',
    //                     environment.apimConfig.apimSubscriptionKey
    //                   );
    //                   newHeaders = newHeaders.append('Ocp-Apim-Trace', 'true');
    //                   newHeaders = newHeaders.append(
    //                     'Caller',
    //                     environment.apimConfig.caller
    //                   );
    //                 }
    //                 if (!!this.authService.accessToken) {
    //                   newHeaders = newHeaders.append(
    //                     'Ad-Authorization',
    //                     this.authService.accessToken
    //                   );
    //                   newHeaders = newHeaders.append(
    //                     'Authorization',
    //                     this.authService.accessToken
    //                   );
    //                 }
    //                 if (!!this.authService.appTokenApi) {
    //                   newHeaders = newHeaders.append(
    //                     'App-Authorization',
    //                     this.authService.appTokenApi
    //                   );
    //                 }
    //                 request = request.clone({ headers: newHeaders });
    //                 return next.handle(request);
    //               });
    //             }
    //           }
    //           return throwError(error);
    //         }
    //         return next.handle(request);
    //       } catch (e) {
    //         return throwError(error);
    //       }
    //     }),
    //     catchError(() => throwError(error))
    //   );
  }

  private checkToken(request: HttpRequest<any>, next: HttpHandler) {

    if (!environment.requireAuthen) {
      return this.continueProcess(request, next);
    }

    return this.authService.extendMsalExpiry().pipe(
      switchMap((result) => {
        try {
          // Check the access token expire date
          if (AuthUtilService.isTokenExpired(this.authService.appToken)) {
            // check if last expiry is within session expiry --> refresh
            const lastActivity = this.common.getLocalStorage(LS_LAST_ACTIVITY);
            if (lastActivity) {
              const now = new Date();
              let lastActivityDate = new Date();
              lastActivityDate.setTime(Number(lastActivity));
              lastActivityDate.setTime(
                lastActivityDate.getTime() +
                  environment.manageAuth.session * 1000
              );
              // extend token if last activity + session time > current date
              if (lastActivityDate.getTime() >= now.getTime()) {
                this.authService.appToken =
                  this.authService.refreshTokenExpiryDate(
                    this.authService.appToken,
                    false
                  );
                // return of(true);
                setTimeout(() => {
                  let newHeaders = request.clone({}).headers;
                  if (
                    environment.apimConfig.apimFlag &&
                    environment.apimConfig.apimSubscriptionKey
                  ) {
                    newHeaders = newHeaders.set(
                      'Ocp_apim_subscription_key',
                      environment.apimConfig.apimSubscriptionKey
                    );
                    newHeaders = newHeaders.set('Ocp-Apim-Trace', 'true');
                    newHeaders = newHeaders.set(
                      'Caller',
                      !!this.authService.loginType &&
                        this.authService.loginType === LOGIN_TYPE_B2C
                        ? environment.apimConfig.callerB2C
                        : environment.apimConfig.caller
                    );
                  }

                  if (!!this.authService.accessToken) {
                    newHeaders = newHeaders.set(
                      'Ad-Authorization',
                      this.authService.accessToken
                    );
                    newHeaders = newHeaders.set(
                      'Authorization',
                      this.authService.accessToken
                    );
                  }
                  if (!!this.authService.appTokenApi) {
                    newHeaders = newHeaders.set(
                      'App-Authorization',
                      this.authService.appTokenApi
                    );
                  }
                  request = request.clone({ headers: newHeaders });
                  // return next.handle(request);
                  return this.continueProcess(request, next);
                });
              }
            }
            return this.handleSessionExpired();
          }
          return this.continueProcess(request, next);
        } catch (e) {
          return throwError(e);
        }
      }),
      catchError(() => this.handleSessionExpired())
    );
  }

  private handleSessionExpired() {
    const redirectURL = this.router.url;
    Swal.fire({
      icon: 'error',
      title: 'Session Expired!',
      text: 'Please sign in again.',
    }).then(() => {
      this.authService.signOut();
      this.router.navigate(['sign-in'], {
        queryParams: { redirectURL },
      });
    });
    return EMPTY;
  }

  private continueProcess(
    requestContinue: HttpRequest<any>,
    nextContinue: HttpHandler
  ) {
    return nextContinue.handle(requestContinue).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // return this.handle401Error(request, next, error);
        }
        return throwError(error);
      })
    );
  }
}
